const MovieData = [
    { 
        id: 1,
        name: "নয় নাম্বার বিপদ সংকেত",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/8CrY1QFvWaG.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
    },
    { 
        id: 2,
        name: "শ্যামল ছায়া",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/QW1KCCz8RWN.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
        
    },
    { 
        id: 3,
        name: "টেলিভিশন",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/GL9qjEoi7Z0.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
    },
    { 
        id: 4,
        name: "নিঃস্বার্থ ভালোবাসা (হোয়াট ইজ লাভ)",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/TpKdFUdYYCw.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
    },
    { 
        id: 5,
        name: "মনপুরা",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/0ZTdi842voN.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
    },
    { 
        id: 6,
        name: "দেবী",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/CLoNk18Z7Ul.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
    },
    { 
        id: 7,
        name: "মুসাফির",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/9lrX5tuqc0o.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
    },
    { 
        id: 8,
        name: "শেষ থেকে শুরু",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/nZO5752955s.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
    },
    { 
        id: 9,
        name: "দেখ কেমন লাগে",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/LRNLHZd3GT3.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
    },
    { 
        id: 10,
        name: "কাটমুণ্ডু",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/W518A3z1Ne1.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
    },
    { 
        id: 11,
        name: "বিবাহ ডায়েরিজ",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/Omj1h8z4K20.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
    },
    { 
        id: 12,
        name: "অমি ও আইসক্রিম'অলা",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/o1dkgtl3QcQ.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
    },
    { 
        id: 13,
        name: "কিরীটি ও কালো ভ্রমর",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/4763O8V75pf.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
    },
    { 
        id: 14,
        name: "প্যান্থার",
        img: "https://cdn.bioscopelive.com/upload/content/landscape/hd/pesZwm8UnyQ.jpg",
        video: "https://www.youtube.com/embed/VOAxl5wwTcY"
    },

];

export default MovieData;